import { render, staticRenderFns } from "./Pay4.vue?vue&type=template&id=73d3c2ad&"
import script from "./Pay4.vue?vue&type=script&lang=js&"
export * from "./Pay4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports